import { render } from "./TermsConditions.vue?vue&type=template&id=39f78cb2&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"

import "./custom-terms.scss?vue&type=style&index=0&id=39f78cb2&lang=scss&scoped=true"
import "./TermsConditions.vue?vue&type=style&index=1&id=39f78cb2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f78cb2"]])

export default __exports__